import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from 'src/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-accent/10 text-accent',
        success: 'border-transparent bg-success-bg text-success',
        warning: 'border-transparent bg-warning-bg text-warning',
        destructive: 'border-transparent bg-danger-bg text-danger',
        info: 'border-transparent bg-info-bg text-info',
        dark: 'border-transparent bg-foreground text-primary',
        secondary: 'border-transparent bg-secondary/10 text-secondary',
        outline: 'bg-transparent border-current',
      },
      size: {
        default: 'px-2.5 py-0.5 text-[11px]',
        sm: 'px-2 py-px text-[10px]',
        lg: 'px-3.5 py-1 text-[13px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

function Badge({ className, variant, size, dot = false, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {dot && <span className='text-[7px] leading-none'>&#9679;</span>}
      {props.children}
    </div>
  );
}

export { Badge, badgeVariants };
